import React, { useEffect, useState } from "react";
import "./BlogComponent.scss"
import BlogItem from "../components/BlogItem/BlogItem";
import { useHistory } from "react-router";
import { getAllBlogPosts } from "../../../../utilities/apiRequests/witmegRetailPaxServerRequests";
import { useDispatch, useSelector } from "react-redux";
import { sortByOrderAscending } from "../helper/helper";
import { setIsComing } from "../../../../../../redux/companyDataSlice";
const BlogComponent = ({ components }) => {
    const history = useHistory()
    const [data, setData] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const companyDetails = useSelector((state) => state.companyData.company)
    const dispatch = useDispatch()

    useEffect(() => {
        fetchData()
    }, [])
    const fetchData = async () => {
        setIsLoading(true)
        let id = companyDetails?.ID ?? ''

        await getAllBlogPosts(id).then((response) => {
            if (response.data) {
                setData(response.data)
            } else {
                setData([])
            }
            setIsLoading(false)

        })
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "VirasatV2DefaultBlog-subheader":
                return <div className="BlogComponent-subheader">- {component?.Props?.text} -</div>
            case "VirasatV2DefaultBlog-headertext":
                return <div className="BlogComponent-header">{component?.Props?.header}
                    <div className="BlogComponent-header-bold">{component?.Props?.highlightedHeader}</div>
                </div>
            case "VirasatV2DefaultBlog-grid":
                return isLoading ? <div className="loader-bloglist" /> : <div className="BlogComponent-grid">
                    {data?.slice(0, 3).map((item, key) => {
                        return (
                            <BlogItem
                                item={item}
                                key={key} />

                        )
                    })
                    }
                </div>
            case "VirasatV2DefaultBlog-button":
                return data?.length > 3 && <div className="BlogComponent-button"
                    onClick={() => {
                        if (component?.Props?.href && component?.Props?.href !== "") {
                            if (component?.Props?.href?.includes("https://")) {
                                window.open(component?.Props?.href, '_blank')
                            } else {
                                history.push(component?.Props?.href,)
                            }
                        }
                        else {
                            dispatch(setIsComing(true))
                        }
                    }} >
                    {component?.Props?.text}
                </div>
            default:
                return <div />
        }

    }
    return (
        data && <div className="BlogComponent">
            {sortByOrderAscending(components).map((component, key) => {
                return (
                    getComponents(component)
                )
            })}
        </div>
    )

}
export default BlogComponent